import ApiService from "@/services/api.service";

const route = 'sync-contracts-and-after-sales';

const SyncContractsAndAfterSales = {
    execute(_data) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${route}`, _data).then(response => {
                resolve({headers: response.headers, data: response.data});
            }, (error) => { 
                reject(error);
            });
        });
    }
};

export default SyncContractsAndAfterSales;